(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = window.matchMedia('(min-width: 900px)').matches;
  var MAX_TIMEOUT = 2147483647;

  function entryState(root) {
    if (!root) return 'open';
    if (root.getAttribute('data-fe-design-mode') === 'true' || (window.Shopify && Shopify.designMode)) {
      return 'open';
    }
    var start = Date.parse(root.getAttribute('data-fe-opens-at') || '');
    var end = Date.parse(root.getAttribute('data-fe-closes-at') || '');
    var now = Date.now();
    if (!isNaN(start) && now < start) return 'soon';
    if (!isNaN(end) && now > end) return 'closed';
    return 'open';
  }

  function reviveScripts(node) {
    node.querySelectorAll('script').forEach(function (oldScript) {
      var script = document.createElement('script');
      Array.prototype.forEach.call(oldScript.attributes, function (attr) {
        script.setAttribute(attr.name, attr.value);
      });
      script.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(script, oldScript);
    });
  }

  function mountEmbed(root) {
    var mount = root.querySelector('[data-fe-giveaway-embed]');
    var template = root.querySelector('[data-fe-embed-template]');
    if (!mount || !template || mount.getAttribute('data-fe-mounted') === 'true') return;
    var wrapper = document.createElement('div');
    wrapper.className = 'fe-giveaway-embed__fallback';
    wrapper.setAttribute('data-fe-embed-clone', 'true');
    wrapper.appendChild(template.content.cloneNode(true));
    mount.appendChild(wrapper);
    reviveScripts(wrapper);
    mount.setAttribute('data-fe-mounted', 'true');
  }

  function unmountEmbed(root) {
    var mount = root.querySelector('[data-fe-giveaway-embed]');
    if (!mount) return;
    mount.querySelectorAll('[data-fe-embed-clone]').forEach(function (node) {
      node.remove();
    });
    mount.removeAttribute('data-fe-mounted');
  }

  function updateEntryCtas(root, state) {
    var soon = root.getAttribute('data-fe-cta-soon');
    var closed = root.getAttribute('data-fe-cta-closed');
    document.querySelectorAll('[data-fe-entry-cta]').forEach(function (button) {
      if (!button.getAttribute('data-fe-cta-original')) {
        button.setAttribute('data-fe-cta-original', (button.textContent || '').replace(/\s+/g, ' ').trim());
      }
      var original = button.getAttribute('data-fe-cta-original');
      var label = original;
      if (state === 'soon' && soon) label = soon;
      if (state === 'closed' && closed) label = closed;
      if (label) button.textContent = label;
    });
  }

  function applyEntryWindow(root) {
    var state = entryState(root);
    root.setAttribute('data-fe-state', state);
    var headingId = 'fe-giveaway-entry-heading-' + state;
    if (document.getElementById(headingId)) {
      root.setAttribute('aria-labelledby', headingId);
    }
    if (state === 'open') {
      mountEmbed(root);
    } else {
      unmountEmbed(root);
    }
    updateEntryCtas(root, state);

    var start = Date.parse(root.getAttribute('data-fe-opens-at') || '');
    var end = Date.parse(root.getAttribute('data-fe-closes-at') || '');
    var now = Date.now();
    var wait = 0;
    if (!isNaN(start) && now < start) wait = start - now + 50;
    else if (!isNaN(end) && now <= end) wait = end - now + 50;
    if (wait > 0 && wait < MAX_TIMEOUT) {
      window.setTimeout(function () {
        applyEntryWindow(root);
      }, wait);
    }
  }

  function track(name, payload) {
    var data = Object.assign({ event: name }, payload || {});

    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (error) {
      /* no-op */
    }

    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push(data);
    }
  }

  function focusEntryHeading(container) {
    var state = container.getAttribute('data-fe-state') || 'open';
    var heading =
      container.querySelector('[data-fe-copy="' + state + '"] h2') ||
      container.querySelector('h2, h1');
    if (!heading) return;
    heading.setAttribute('tabindex', '-1');
    heading.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (event) {
    var scrollLink = event.target.closest('[data-fe-scroll]');
    if (scrollLink) {
      var href = scrollLink.getAttribute('href');
      if (href && href.charAt(0) === '#') {
        var target = document.querySelector(href);
        if (target) {
          event.preventDefault();
          target.scrollIntoView({
            behavior: reduceMotion ? 'auto' : 'smooth',
            block: 'start'
          });
          focusEntryHeading(target);
          track('giveaway_scroll_to_entry', {
            source: scrollLink.getAttribute('data-fe-track') || 'scroll'
          });
        }
      }
    }

    var tracked = event.target.closest('[data-fe-track]');
    if (!tracked) return;

    track('giveaway_' + tracked.getAttribute('data-fe-track'), {
      label: (tracked.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80)
    });
  });

  var entry = document.getElementById('giveaway-entry');
  if (entry) {
    applyEntryWindow(entry);
  }
  if (entry && 'IntersectionObserver' in window) {
    var viewed = false;
    var entryObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (item) {
          if (!item.isIntersecting || viewed) return;
          viewed = true;
          track('giveaway_entry_viewed', { id: 'giveaway-entry' });
        });
      },
      { threshold: 0.28 }
    );
    entryObserver.observe(entry);
  }

  if ('IntersectionObserver' in window && !reduceMotion) {
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (item) {
          if (!item.isIntersecting) return;
          item.target.classList.add('is-visible');
          revealObserver.unobserve(item.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    document.querySelectorAll('[data-fe-reveal]').forEach(function (node) {
      revealObserver.observe(node);
    });
  } else {
    document.querySelectorAll('[data-fe-reveal]').forEach(function (node) {
      node.classList.add('is-visible');
    });
  }

  var media = document.querySelector('.fe-giveaway-hero__media');
  if (media && !reduceMotion && desktop) {
    var ticking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var rect = media.getBoundingClientRect();
          if (rect.bottom > 0 && rect.top < window.innerHeight) {
            var offset = Math.max(-28, Math.min(28, rect.top * -0.06));
            media.style.transform = 'translate3d(0,' + offset + 'px,0) scale(1.08)';
          }
          ticking = false;
        });
      },
      { passive: true }
    );
  }
})();
